export class User {
    public usuarioId: number;
    public apellidoPaterno: string;
    public apellidoMaterno: string;
    public login: string;
    public nombre: string;
    public sNombre: string;
    public token: string;
    public primeraVez: boolean;
    public rolId: number;
    public menu: [];
    public subMenu: [];
    public recordatorioCaducidad:boolean;
    public mensajeCaducidad:string;
    public password: string;
    public perfil: Perfil;
}

export class Perfil {
  public nombre: string;
  public fechaNacimiento: string;
  public correo: string;
  public rol: string;
  public login: string;
  public imagenPerfilUrl: string;
  public imagenPerfilBase64:string;
}